import React, { useEffect, useState } from 'react'
import { clearFilter } from '../components/LocalInventories/filterConfig'
import apiClient from '../utils/api/apiClient'
import { APIEndpoints } from '../utils/api/apiConfig'
import axios from 'axios'

const CancelToken = axios.CancelToken;
let cancel;

const LocalInventoriesContext = React.createContext({})
export function useLocalInventoriesState() {
  return React.useContext(LocalInventoriesContext)
}
const initialFilter = {
  'filter.articleNumber': '',
  'filter.articleName': '',
  'filter.sizeName': '',
  'filter.serialkey': '',
  'filter.batchKey': '',
  'filter.storehouseCoordinatesOrNameFilter': ''
}

const LocalInventoriesProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false)
  const [pageOffset, setPageOffset] = useState(0)
  const [pageLimit, setPageLimit] = useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [showAllLocalInventories, setShowAllLocalInventories] = useState(false)
  const [filter, setFilter] = useState(initialFilter)
  const [sorting, setSorting] = useState('articleNumber')
  const [selectedRow, setSelectedRow] = useState(false)
  const [localInventories, setLocalInventories] = useState([])
  const [tableIsLoading, setTableIsLoading] = useState(false)
  const [showOverlayLeft, setShowOverlayLeft] = useState(false)
  const [filterLocalInventory, setFilterLocalInventory] = useState(null)
  const [forceReloadLocalInventories, setForceReloadLocalInventories] = useState(false)
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([])
  const [allCheckBoxesSelected, setAllCheckBoxesSelected] = useState(false)
  const [allSelectedLoading, setAllSelectedLoading] = useState(false)
  const [initialTableId, setInitialTableId] = useState(null)
  const [modifiedLocalInventories, setModifiedLocalInventories] = useState([])

  const [lastParams, setLastParams] = useState(JSON.stringify({
    pageOffset,
    pageLimit,
    filter,
    showAllLocalInventories,
    sorting
  }))
  const resetFilter = (test = null) => {
    clearFilter()
    setFilter(initialFilter)

    if (!showAllLocalInventories) {
      setLocalInventories([])
      setTotalCount(0)
    }

  }
  const resetModifiedSelections = () => {
    setAllCheckBoxesSelected(false)
    setSelectedCheckBoxes([])
    setModifiedLocalInventories([])
  }
  const handleLocalChangeCheckbox = id => {
    if (allCheckBoxesSelected) {
      setAllCheckBoxesSelected(false)
    }
    if (selectedCheckBoxes.includes(id)) {
      var index = selectedCheckBoxes.indexOf(id);
      var newValues = [...selectedCheckBoxes]
      newValues.splice(index, 1);
      setSelectedCheckBoxes(newValues)
    }
    else {
      setSelectedCheckBoxes(prev => [...prev, id])
    }
    var modValues = [...modifiedLocalInventories]
    let modIndex = modValues.findIndex(item => item.id === id)
    if(modIndex>=0)
    {
      modValues.splice(modIndex, 1);
      setModifiedLocalInventories(modValues)
    }
    else
    {
      let inventory = localInventories.find(item => item.id === id)
      if(inventory)
      {
        modValues.push(inventory);
        setModifiedLocalInventories(modValues)
      }
    }
  }

  //cancel previous calls that are still pending if existing
  const cancelPrevious = () => {
    cancel && cancel()
  }

  const loadLocalInventories = async () => {
    cancelPrevious()
    const cancelToken = new CancelToken(function executor(c) {
      cancel = c;
    })
    try {
      let params = getParams()
      const response = await apiClient.getJson(APIEndpoints.localstock().localInventories, params, true, true, true, { cancelToken })
      if (response.headers['x-total-count']) {
        setTotalCount(Number(response.headers['x-total-count']))
      } else { setTotalCount(0) }
      return response.data
    }
    catch (e) {
      if (axios.isCancel(e)) {
        console.log("cancelled by cancelToken")
      }
      return null
    }
  }

  const getParams = () => {
    const filterWithValues = { ...filter }
    Object.keys(filterWithValues).forEach(filterName => {
      if (filterWithValues[filterName] === '') {
        delete filterWithValues[filterName]
      }
    })
    let params = { ...filterWithValues }
    params['page.offset'] = pageOffset
    params['page.limit'] = pageLimit
    if (sorting) {
      params['sort'] = sorting
    }
    return params
  }
  const prepareUIID = (data) => {
    return data.storehouseId+'_'+data.articleId+'_'+data.sizeId+'_'+data.serialkey+'_'+data.batchKey;
  }
  const appendData = (data) => {
    return data.map(item => ({
      ...item, 
      id: prepareUIID(item),
      counted: item.quantity,
      checkBox: (
        <span>
          <input type="checkbox" id={prepareUIID(item)} name="scales"
            checked={selectedCheckBoxes.includes(prepareUIID(item))} onChange={() => { }}>
          </input>
        </span>
      )
    }))
  }

  useEffect(() => {
    const newParams = JSON.stringify({ pageOffset, pageLimit, filter, showAllLocalInventories, sorting })
    const filtersHaveChanged = JSON.stringify(filter) !== JSON.stringify(JSON.parse(lastParams).filter)
    const sortingHasChanged = JSON.stringify(sorting) !== JSON.stringify(JSON.parse(lastParams).sorting)
    //go to page 1 if filter or sorting have changed
    if (pageOffset !== 0 && (sortingHasChanged || filtersHaveChanged)) {
      var newParamsFilter = JSON.parse(lastParams)
      newParamsFilter.filter = filter
      newParamsFilter.sorting = sorting
      setLastParams(JSON.stringify(newParamsFilter))
      setPageOffset(0)
    }
    else if (lastParams !== newParams || forceReloadLocalInventories) {
      setForceReloadLocalInventories(false);
      setLastParams(newParams);
      (async () => {
        if (showAllLocalInventories || Object.keys(filter).reduce((acc, item) => (acc || filter[item] !== ''), false)) {
          setTableIsLoading(true)
          const result = await loadLocalInventories()
          if (result) {
            // add action icons
            let preparedResult = appendData(result)
            setLocalInventories(preparedResult)
            setTableIsLoading(false)
          }
        } else {
          cancelPrevious()
          setLocalInventories([])
          setModifiedLocalInventories([])
          setTotalCount(0)
          setTableIsLoading(false)
        }
        if (filtersHaveChanged) {
          //setSelectedCheckBoxes([])
          setAllCheckBoxesSelected(false)
        }
      })()
    }
    //eslint-disable-next-line
  }, [pageOffset, pageLimit, filter, showAllLocalInventories, sorting, forceReloadLocalInventories, setForceReloadLocalInventories])


  const selectAll = () => {
    if (allCheckBoxesSelected || (localInventories.length < 1)) {
      setAllCheckBoxesSelected(false)
      setSelectedCheckBoxes([])
      setModifiedLocalInventories([])
    }
    else {
      setAllSelectedLoading(true)
      const filterWithValues = { ...filter }
      Object.keys(filterWithValues).forEach(filterName => {
        if (filterWithValues[filterName] === '') {
          delete filterWithValues[filterName]
        }
      })

      apiClient.getJson(APIEndpoints.localstock().localInventories, { ...filterWithValues }).then(result => {
        if (result) {
          //const arrayOfAllIds = result.map(obj => prepareUIID(obj))
          let preparedResult = appendData(result)
          setModifiedLocalInventories(preparedResult)
          const arrayOfAllIds = preparedResult.map(obj => prepareUIID(obj))
          setSelectedCheckBoxes(arrayOfAllIds)
        }
      }).finally(() => { setAllCheckBoxesSelected(true); setAllSelectedLoading(false) })
    }
  }


  useEffect(() => {
    // add action icons
    // todo only change selected one

    setLocalInventories(prev => (prev.map(item => ({
      ...item,
      checkBox: (
        <span>
          <input type="checkbox" id={item.id} name="scales"
            checked={selectedCheckBoxes.includes(item.id)} onChange={() => { }}>
          </input>
        </span>
      )
    }))))
  }, [selectedCheckBoxes])




  const contextValues = {
    setSelectedCheckBoxes,
    allCheckBoxesSelected,
    selectAll,
    allSelectedLoading,
    selectedCheckBoxes,
    handleLocalChangeCheckbox,
    loaded,
    setLoaded,
    pageOffset,
    setPageOffset,
    pageLimit,
    setPageLimit,
    totalCount,
    setTotalCount,
    showAllLocalInventories,
    setShowAllLocalInventories,
    filter,
    setFilter,
    localInventories,
    setLocalInventories,
    selectedRow,
    setSelectedRow,
    sorting,
    setSorting,
    resetFilter,
    tableIsLoading,
    showOverlayLeft,
    setShowOverlayLeft,
    filterLocalInventory,
    setFilterLocalInventory,
    forceReloadLocalInventories,
    setForceReloadLocalInventories,
    initialTableId, setInitialTableId,
    modifiedLocalInventories, setModifiedLocalInventories, resetModifiedSelections
  }
  return (
    <LocalInventoriesContext.Provider value={contextValues}>
      {children}
    </LocalInventoriesContext.Provider>
  )
}

export default LocalInventoriesProvider
